import type { IconsNames } from '@eqi-investimentos/icons/web';

export type MenuType = {
  name: string;
  iconName: IconsNames | null;
  hasAccess?: boolean;
  description?: string | null;
  target?: string;
  order?: number;
} & (
  | {
      url: string;
      submenu?: never;
    }
  | {
      url?: never;
      submenu: MenuType[];
    }
);

export const fallbackMenu: MenuType[] = [
  {
    name: 'Minhas Finanças',
    description: null,
    url: '/minhas-financas',
    order: 1,
    hasAccess: true,
    target: '_self',
    iconName: 'PieChart',
  },
  {
    name: 'EQI Research',
    description: null,
    url: '/research',
    order: 2,
    hasAccess: true,
    target: '_self',
    iconName: 'ImportantDevicesOutline',
  },
  {
    name: 'Macro Trends',
    description: null,
    url: '/research/programa/macro-trends',
    order: 3,
    hasAccess: true,
    target: '_self',
    iconName: 'Earth',
  },
  {
    name: 'Investir',
    description: null,
    url: '/investimentos',
    order: 4,
    hasAccess: true,
    target: '_self',
    iconName: 'Stocks',
  },
  {
    name: 'Planejador Financeiro',
    description: null,
    url: '/planejamento-financeiro',
    order: 5,
    hasAccess: true,
    target: '_self',
    iconName: 'ListAltOutline',
  },
  {
    name: 'EQI Traders',
    description: null,
    url: '/eqi-trader',
    order: 6,
    hasAccess: true,
    target: '_self',
    iconName: 'GraphicEq',
  },
  {
    name: 'Serviços',
    description: null,
    order: 7,
    hasAccess: true,
    target: '_self',
    iconName: 'WorldNetwork',
    submenu: [
      {
        name: 'Cartões',
        description: null,
        url: '/cartao-de-credito',
        order: 1,
        hasAccess: true,
        target: '_self',
        iconName: 'CardOutline',
      },
      {
        name: 'Empresarial',
        description: null,
        url: '/empresarial',
        order: 2,
        hasAccess: true,
        target: '_self',
        iconName: 'Building',
      },
      {
        name: 'Câmbio',
        description: null,
        url: '/cambio',
        order: 3,
        hasAccess: true,
        target: '_self',
        iconName: 'ExchangeOutline',
      },
      {
        name: 'Aquisição de bens',
        description: null,
        url: '/aquisicao-de-bens',
        order: 4,
        hasAccess: true,
        target: '_self',
        iconName: 'KeyOutline',
      },
      {
        name: 'Seguros',
        description: null,
        url: '/seguro-vida',
        order: 5,
        hasAccess: true,
        target: '_self',
        iconName: 'ShieldOutline',
      },
      {
        name: 'Assessoria Renda Variável',
        description: null,
        url: '/assessoria-renda-variavel',
        order: 6,
        hasAccess: true,
        target: '_self',
        iconName: 'GraphicEq',
      },
    ],
  },
  {
    name: 'Notícias',
    description: null,
    url: '/noticias',
    order: 8,
    hasAccess: true,
    target: '_self',
    iconName: 'CupOutline',
  },
  {
    name: 'Cursos',
    description: null,
    url: '/cursos',
    order: 9,
    hasAccess: true,
    target: '_self',
    iconName: 'SchoolOutline',
  },
  {
    name: 'Filmes e Séries',
    description: null,
    url: '/filmes',
    order: 10,
    hasAccess: true,
    target: '_self',
    iconName: 'LiveTvOutline',
  },
];
